export default {
  namespaced: true,
  state: {
    networkState: '',
    requestshow:false,
    orderDTO:{
      aaa:'1'
    },
    enumeration:'',
  },
  mutations: {
    updateNetworkState(state, payload) {
      state.networkState = payload.networkState
    },
    setrequestshow(state,data){
    	state.requestshow = data
    },
    setOrderDTO(state,data){
      state.orderDTO = data
    },
    setEnumeration(state,data){
      state.enumeration = data
    }
  },
  actions:{
    
  }
}
